/**
 * Combines two AbortSignals so that aborting either one aborts the result.
 * Uses AbortSignal.any() where available, with a manual fallback for older
 * browsers (Safari < 17.4, Chrome < 123).
 */
export function combineAbortSignals(a, b) {
    if (typeof AbortSignal.any === 'function') {
        return AbortSignal.any([a, b]);
    }
    // Manual fallback: create a new controller and forward abort from either input.
    const controller = new AbortController();
    const onAbort = () => {
        controller.abort(a.aborted ? a.reason : b.reason);
        a.removeEventListener('abort', onAbort);
        b.removeEventListener('abort', onAbort);
    };
    if (a.aborted || b.aborted) {
        controller.abort(a.aborted ? a.reason : b.reason);
        return controller.signal;
    }
    a.addEventListener('abort', onAbort);
    b.addEventListener('abort', onAbort);
    return controller.signal;
}
//# sourceMappingURL=combineAbortSignals.js.map